var login = {
  translation: {
    common: {
      accept: 'Chấp nhận',
      alreadyUser: 'Đã có tài khoản?',
      and: 'và',
      backToLogin: 'Quay lại trang đăng nhập',
      continueWith: 'Tiếp tục với {{provider}}',
      createAccount: 'Tạo tài khoản',
      createYourAccount: 'Tạo tài khoản của bạn',
      emailOrUsername: 'Email hoặc tên đăng nhập',
      login: 'Đăng nhập',
      logInToBoards: 'Đăng nhập',
      newToBoards: 'Lần đầu dùng RICE-WORK?',
      pageNotFound_title: 'Không tìm thấy trang',
      password: 'Mật khẩu',
      privacyPolicy: 'Chính sách bảo mật',
      register: 'Đăng ký',
      registerWithGoogle: 'Đăng ký bằng Google',
      termsOfService: 'Điều khoản dịch vụ',
      togglePasswordVisibility: 'Bật/tắt hiển thị mật khẩu',
    },

    action: {
      logIn: 'Đăng nhập',
    },
  },
};

export { login as default };
